import React, { Component } from 'react'
import './HSGTabs.css'

class Tabs extends Component {	
	update(index, nav, label, e) {
		e.preventDefault();
		this.props.changeTab(index, nav)
	}

	_renderTitles = () => {
		function getLabels(child, index) {
			let { nav, label } = child.props
			var activeClass = (this.props.selected === nav ? '-selected' : '')
			return (
				<li key={index}>
					<div onClick={this.update.bind(this, index, nav, label)} className={'hsg-tab'+activeClass}>
						{child.props.label ? child.props.label.toUpperCase() : ''}&nbsp;
						{
							(
								(
									child.props.badge !== 0
									&&
									child.props.badge !== undefined
								)
								&&
								activeClass !== '-selected'
							)
							&&
							<span className="hsg-badge">{child.props.badge}</span>
						}
					</div>
				</li>
			)
		}
		return (
			<div className="tab-bottom">
				<ul className="tabs__labels">
					{this.props.children ? this.props.children.map(getLabels.bind(this)) : ''}
				</ul>
			</div>
		)
	}

	render() {
		return (
			<div className={this.props.className}>
				{this._renderTitles()}
			</div>
		)
	}
}

export default Tabs

Tabs.defaultProps = {
    selected: 'school'
}


// WEBPACK FOOTER //
// ./src/Containers/HSGTabs/Component/HSGTabs.js